<h2 class="text-2xl font-bold mb-3 text-duck-blue-1">{{ referralInfo()?.header }}</h2>
<div [innerHTML]="referralInfo()?.content | markdown" class="description"></div>
@if (referralInfo()?.author) {
  <div class="mt-4 text-sm text-grey-5">
    Uppdaterad: {{ updateDateFull() }}<br>
    Författare:
    @if (referralInfo()?.author.email) {
      <a href="mailto:{{ referralInfo()?.author.email }}" class="text-duck-blue-2">
        {{ referralInfo()?.author.name }}</a>@if (referralInfo()?.author.credentials) {
        ,
      }
    } @else {
      {{ referralInfo()?.author.name }}@if (referralInfo()?.author.credentials) {
        ,
      }
    }
    @if (referralInfo()?.author.credentials) {
      <span class="italic">{{ referralInfo()?.author.credentials }}</span>
    }
  </div>
}

